export interface NewsItem {
  id: number;
  date: string;
  title: string;
  source: string;
  category: string;
  summary: string;
  tags: string[];
  url: string;
}

export const newsTimelineData: NewsItem[] = [
  {
    id: 1,
    date: '2026-03-28',
    title: 'Meta发布Quest 4 Pro，裸眼3D技术首次商用，元宇宙体验跨越式升级',
    source: 'The Verge',
    category: 'XR设备',
    summary: 'Meta正式发布Quest 4 Pro头显，搭载全新裸眼3D显示技术，无需佩戴眼镜即可感受立体全息影像。设备重量降至180克，续航提升至12小时，售价1299美元。',
    tags: ['Meta', 'XR', '裸眼3D', '元宇宙'],
    url: '#',
  },
  {
    id: 2,
    date: '2026-03-15',
    title: '中国6G标准正式发布，峰值速率达1Tbps，全球首个6G商用网络在深圳启动',
    source: '新华社',
    category: '6G网络',
    summary: '工业和信息化部正式发布中国6G技术标准，深圳成为全球首个6G商用城市。6G网络峰值速率达1Tbps，端到端延迟低于0.1ms，为元宇宙大规模商用奠定基础。',
    tags: ['6G', '中国', '深圳', '通信'],
    url: '#',
  },
  {
    id: 3,
    date: '2026-03-02',
    title: 'Neuralink完成第100例人体脑机接口植入，意念打字速度突破每分钟200词',
    source: 'MIT Technology Review',
    category: '脑机接口',
    summary: 'Neuralink宣布完成第100例人体脑机接口植入手术，最新数据显示患者意念打字速度突破每分钟200词，超越普通人键盘打字速度。马斯克表示2027年将推出消费级产品。',
    tags: ['脑机接口', 'Neuralink', 'BCI', '神经科技'],
    url: '#',
  },
  {
    id: 4,
    date: '2026-02-20',
    title: '谷歌量子计算机"Willow-2"实现1000量子比特稳定运行，量子优势全面确立',
    source: 'Nature',
    category: '量子计算',
    summary: '谷歌发布新一代量子计算机Willow-2，实现1000个逻辑量子比特的稳定运行，量子纠错技术取得突破性进展。该计算机在特定任务上的速度是最快超算的10^30倍。',
    tags: ['量子计算', '谷歌', '量子优势', '科技突破'],
    url: '#',
  },
  {
    id: 5,
    date: '2026-02-08',
    title: '腾讯元宇宙平台"超级QQ秀"月活突破5亿，成全球最大中文元宇宙社交平台',
    source: '腾讯科技',
    category: '元宇宙平台',
    summary: '腾讯旗下元宇宙社交平台超级QQ秀月活跃用户突破5亿，成为全球最大中文元宇宙社交平台。平台内虚拟经济规模达500亿元，数字时装、虚拟房产等成为热门消费品类。',
    tags: ['腾讯', '元宇宙', '社交', '数字经济'],
    url: '#',
  },
  {
    id: 6,
    date: '2026-01-25',
    title: 'Web5.0协议联盟正式成立，苹果、微软、阿里巴巴等200家企业联合签署',
    source: 'TechCrunch',
    category: 'Web5.0',
    summary: 'Web5.0协议联盟在达沃斯论坛正式宣告成立，苹果、微软、谷歌、阿里巴巴、腾讯等200家全球科技巨头联合签署协议，共同推进去中心化身份与数据主权标准。',
    tags: ['Web5.0', '去中心化', '数字身份', '协议'],
    url: '#',
  },
  {
    id: 7,
    date: '2026-01-12',
    title: '波士顿动力人形机器人Atlas 3.0开始量产，售价降至8万美元，工厂部署加速',
    source: 'Bloomberg',
    category: '人形机器人',
    summary: '波士顿动力宣布Atlas 3.0人形机器人正式量产，售价降至8万美元，较上一代降低60%。首批订单来自特斯拉、富士康等制造业巨头，预计2026年底部署超过10万台。',
    tags: ['人形机器人', '波士顿动力', '制造业', 'AI'],
    url: '#',
  },
  {
    id: 8,
    date: '2025-12-30',
    title: '2025年全球元宇宙市场规模突破8000亿美元，中国占比达35%',
    source: 'IDC',
    category: '市场报告',
    summary: 'IDC发布2025年全球元宇宙市场报告，全年市场规模突破8000亿美元，同比增长180%。中国市场占比35%，成为全球最大元宇宙市场，深圳、上海、北京成为三大元宇宙产业中心。',
    tags: ['市场报告', '元宇宙', '中国', '数字经济'],
    url: '#',
  },
  {
    id: 9,
    date: '2025-12-18',
    title: 'OpenAI发布GPT-6，多模态能力全面超越人类专家，AGI时代正式开启',
    source: 'OpenAI Blog',
    category: 'AI',
    summary: 'OpenAI正式发布GPT-6，在医学、法律、科学研究等专业领域全面超越人类顶尖专家。GPT-6具备完整的视觉、听觉、触觉多模态理解能力，被业界认为是AGI时代的正式开启。',
    tags: ['AI', 'GPT-6', 'AGI', 'OpenAI'],
    url: '#',
  },
  {
    id: 10,
    date: '2025-12-05',
    title: '华为发布全球首款6G手机，支持全息通话，元宇宙随时随地触手可及',
    source: '华为官网',
    category: '6G设备',
    summary: '华为正式发布全球首款6G商用手机Mate 80 Ultra，支持全息通话功能，用户可在手机上看到对方的3D全息影像。设备内置元宇宙入口，支持直接进入主流元宇宙平台。',
    tags: ['华为', '6G', '全息通话', '元宇宙'],
    url: '#',
  },
  {
    id: 11,
    date: '2025-11-22',
    title: '比特币突破20万美元，区块链技术在元宇宙数字资产领域全面落地',
    source: 'CoinDesk',
    category: '区块链',
    summary: '比特币价格突破20万美元历史新高，市值超越黄金总量。区块链技术在元宇宙数字资产确权、NFT交易、虚拟土地所有权等领域全面落地，数字资产经济体系日趋成熟。',
    tags: ['区块链', '比特币', 'NFT', '数字资产'],
    url: '#',
  },
  {
    id: 12,
    date: '2025-11-10',
    title: '苹果Vision Pro 3发布，重量仅150克，成为首款真正意义上的日常佩戴XR设备',
    source: 'Apple Newsroom',
    category: 'XR设备',
    summary: '苹果发布Vision Pro 3，重量降至150克，续航提升至全天候使用。搭载M5芯片，支持实时空间计算与AI增强现实，被认为是XR设备从专业工具走向日常消费品的里程碑。',
    tags: ['苹果', 'Vision Pro', 'XR', '空间计算'],
    url: '#',
  },
  {
    id: 13,
    date: '2025-10-28',
    title: '中国发布《元宇宙产业发展规划（2025-2030）》，万亿级产业生态加速构建',
    source: '工业和信息化部',
    category: '政策',
    summary: '工业和信息化部正式发布《元宇宙产业发展规划（2025-2030）》，明确到2030年元宇宙核心产业规模突破5万亿元，带动相关产业超过20万亿元，打造全球元宇宙产业高地。',
    tags: ['政策', '元宇宙', '中国', '产业规划'],
    url: '#',
  },
  {
    id: 14,
    date: '2025-10-15',
    title: 'SpaceX星链第三代卫星全面部署，全球6G卫星互联网覆盖率达99.9%',
    source: 'SpaceX',
    category: '卫星互联网',
    summary: 'SpaceX完成第三代星链卫星全面部署，全球6G卫星互联网覆盖率达99.9%，包括南极洲、深海等极端环境。卫星网络与地面6G网络无缝融合，真正实现全球无死角超高速连接。',
    tags: ['SpaceX', '星链', '卫星互联网', '6G'],
    url: '#',
  },
  {
    id: 15,
    date: '2025-09-30',
    title: '数字孪生地球项目启动，NASA与阿里云合作构建全球首个实时地球数字镜像',
    source: 'NASA',
    category: '数字孪生',
    summary: 'NASA与阿里云联合宣布启动"数字孪生地球"项目，计划在2028年前构建全球首个实时更新的地球数字镜像，用于气候预测、灾害预警、城市规划等领域，精度达到厘米级。',
    tags: ['数字孪生', 'NASA', '阿里云', '气候'],
    url: '#',
  },
  {
    id: 16,
    date: '2025-09-18',
    title: '三星发布全球首款量子加密手机，元宇宙通信安全进入新时代',
    source: '三星官网',
    category: '量子安全',
    summary: '三星发布Galaxy Quantum 5，搭载全球首款消费级量子加密芯片，通话、消息、元宇宙交互全程量子加密保护。该技术被认为是应对未来量子计算机破解威胁的关键防线。',
    tags: ['三星', '量子加密', '安全', '元宇宙'],
    url: '#',
  },
  {
    id: 17,
    date: '2025-09-05',
    title: '全球首个元宇宙奥运会举办，来自180个国家的运动员在虚拟赛场同台竞技',
    source: 'IOC',
    category: '元宇宙活动',
    summary: '国际奥委会主办的首届元宇宙奥运会在全球同步举行，来自180个国家的运动员通过XR设备在虚拟赛场竞技。全球观看人数突破30亿，创造人类历史上最大规模的虚拟体育赛事。',
    tags: ['元宇宙', '奥运会', 'XR', '体育'],
    url: '#',
  },
  {
    id: 18,
    date: '2025-08-22',
    title: 'DeepMind AlphaFold 3攻克蛋白质设计难题，量子计算加速新药研发',
    source: 'DeepMind',
    category: 'AI+量子',
    summary: 'DeepMind发布AlphaFold 3，结合量子计算技术，不仅能预测蛋白质结构，还能设计全新蛋白质。该技术将新药研发周期从10年压缩至1年，被认为是医学史上最重要的突破之一。',
    tags: ['AI', '量子计算', '医疗', 'DeepMind'],
    url: '#',
  },
  {
    id: 19,
    date: '2025-08-10',
    title: '字节跳动元宇宙平台"Pico World"用户突破3亿，成为全球增速最快的元宇宙平台',
    source: '字节跳动',
    category: '元宇宙平台',
    summary: '字节跳动旗下Pico World元宇宙平台用户突破3亿，成为全球增速最快的元宇宙平台。平台内容创作者超过500万，月均内容产出超过1000万件，虚拟演唱会、元宇宙展览成为爆款。',
    tags: ['字节跳动', 'Pico', '元宇宙', '内容创作'],
    url: '#',
  },
  {
    id: 20,
    date: '2025-07-28',
    title: '欧盟通过《元宇宙数字权利宪章》，全球首个元宇宙用户权利法律框架建立',
    source: 'EU Commission',
    category: '政策法规',
    summary: '欧盟议会正式通过《元宇宙数字权利宪章》，明确用户在元宇宙中的隐私权、数字资产所有权、虚拟身份保护权等核心权利，成为全球首个元宇宙用户权利法律框架。',
    tags: ['欧盟', '法规', '数字权利', '元宇宙'],
    url: '#',
  },
  {
    id: 21,
    date: '2025-07-15',
    title: '英伟达发布Blackwell Ultra GPU，元宇宙实时渲染性能提升10倍',
    source: 'NVIDIA',
    category: '芯片',
    summary: '英伟达发布Blackwell Ultra架构GPU，AI推理性能较上代提升10倍，实时光线追踪能力使元宇宙场景渲染质量达到电影级别。该芯片将成为下一代XR设备和元宇宙服务器的核心。',
    tags: ['英伟达', 'GPU', '元宇宙渲染', '芯片'],
    url: '#',
  },
  {
    id: 22,
    date: '2025-07-02',
    title: '中国脑机接口国家标准发布，非侵入式BCI设备进入医疗器械审批快速通道',
    source: '国家药品监督管理局',
    category: '脑机接口',
    summary: '国家药品监督管理局发布中国脑机接口技术国家标准，非侵入式BCI设备进入医疗器械审批快速通道。华为、百度、科大讯飞等企业已提交首批BCI产品审批申请。',
    tags: ['脑机接口', '中国', '标准', '医疗'],
    url: '#',
  },
  {
    id: 23,
    date: '2025-06-20',
    title: '全球首个AI法官在新加坡上线，区块链存证+AI裁决实现元宇宙纠纷自动化处理',
    source: 'Reuters',
    category: 'AI+区块链',
    summary: '新加坡最高法院宣布全球首个AI法官系统正式上线，专门处理元宇宙数字资产纠纷。系统结合区块链存证与AI裁决，平均处理时间从6个月缩短至48小时，准确率达97.3%。',
    tags: ['AI', '区块链', '法律', '元宇宙'],
    url: '#',
  },
  {
    id: 24,
    date: '2025-06-08',
    title: '特斯拉Optimus机器人开始在工厂独立完成复杂装配任务，效率超越人类工人',
    source: 'Tesla',
    category: '人形机器人',
    summary: '特斯拉宣布Optimus机器人在上海超级工厂开始独立完成复杂装配任务，效率比人类工人高出30%，错误率低于0.01%。马斯克表示2026年将部署超过10万台Optimus机器人。',
    tags: ['特斯拉', 'Optimus', '机器人', '制造业'],
    url: '#',
  },
  {
    id: 25,
    date: '2025-05-25',
    title: '微软Azure量子云平台向全球开发者开放，元宇宙量子应用开发时代来临',
    source: 'Microsoft',
    category: '量子计算',
    summary: '微软Azure量子云平台正式向全球开发者开放，提供量子计算资源租用服务。首批应用场景包括元宇宙物理模拟、量子加密通信、AI模型训练加速，月费从99美元起。',
    tags: ['微软', '量子计算', '云计算', '开发者'],
    url: '#',
  },
  {
    id: 26,
    date: '2025-05-12',
    title: '韩国首尔完成全球首个城市级元宇宙部署，市民可在虚拟首尔办理所有政务',
    source: '首尔市政府',
    category: '智慧城市',
    summary: '首尔市政府宣布完成全球首个城市级元宇宙部署，市民可通过XR设备在虚拟首尔办理所有政务、参加市政会议、访问公共服务。虚拟首尔已有超过200万市民注册使用。',
    tags: ['首尔', '智慧城市', '元宇宙', '政务'],
    url: '#',
  },
  {
    id: 27,
    date: '2025-04-30',
    title: 'Roblox宣布进军教育元宇宙，与全球1000所大学合作打造沉浸式学习平台',
    source: 'Roblox',
    category: '教育元宇宙',
    summary: 'Roblox宣布与全球1000所顶尖大学合作，打造教育元宇宙平台Roblox Education。学生可在虚拟实验室进行化学实验、在历史场景中学习历史、在虚拟手术室练习医学技能。',
    tags: ['Roblox', '教育', '元宇宙', '大学'],
    url: '#',
  },
  {
    id: 28,
    date: '2025-04-18',
    title: '中国量子通信骨干网"京沪干线2.0"升级完成，量子密钥分发速率提升100倍',
    source: '中国科学技术大学',
    category: '量子通信',
    summary: '中国量子通信骨干网京沪干线2.0升级完成，量子密钥分发速率提升100倍，覆盖范围扩展至全国主要城市。该网络将为元宇宙金融交易、政务通信提供绝对安全的量子加密保护。',
    tags: ['量子通信', '中国', '安全', '网络'],
    url: '#',
  },
  {
    id: 29,
    date: '2025-04-05',
    title: 'Meta Connect 2025：扎克伯格宣布元宇宙用户突破10亿，Horizon Worlds全面开放',
    source: 'Meta',
    category: '元宇宙平台',
    summary: 'Meta在Connect 2025大会上宣布元宇宙平台用户突破10亿里程碑，Horizon Worlds向全球用户全面开放。扎克伯格表示元宇宙已成为继移动互联网之后最重要的计算平台。',
    tags: ['Meta', 'Horizon Worlds', '元宇宙', '扎克伯格'],
    url: '#',
  },
  {
    id: 30,
    date: '2025-03-22',
    title: '全球首个元宇宙医院在上海开业，AI医生+远程手术机器人服务全球患者',
    source: '上海交通大学医学院',
    category: '医疗元宇宙',
    summary: '全球首个元宇宙医院在上海正式开业，患者可通过XR设备在家中接受AI医生诊断，复杂手术由远程机器人在医生指导下完成。首月接诊患者超过10万人次，覆盖全球50个国家。',
    tags: ['医疗', '元宇宙', 'AI', '机器人手术'],
    url: '#',
  },
  {
    id: 31,
    date: '2025-03-10',
    title: 'Web3.0去中心化社交平台Farcaster用户突破1亿，传统社交媒体面临颠覆',
    source: 'Farcaster',
    category: 'Web3.0',
    summary: 'Web3.0去中心化社交平台Farcaster用户突破1亿，用户完全拥有自己的数据和内容。平台内容创作者收入比传统平台高出300%，被认为是Web3.0社交革命的标志性事件。',
    tags: ['Web3.0', '去中心化', '社交', 'Farcaster'],
    url: '#',
  },
  {
    id: 32,
    date: '2025-02-25',
    title: '任天堂发布元宇宙游戏平台Nintendo World，马里奥等经典IP进入元宇宙',
    source: '任天堂',
    category: '游戏元宇宙',
    summary: '任天堂发布元宇宙游戏平台Nintendo World，马里奥、塞尔达、宝可梦等经典IP以全新形式进入元宇宙。玩家可在虚拟世界中与经典角色互动，平台首日注册用户突破5000万。',
    tags: ['任天堂', '游戏', '元宇宙', 'IP'],
    url: '#',
  },
  {
    id: 33,
    date: '2025-02-12',
    title: '百度文心大模型5.0发布，中文元宇宙AI助手能力全面超越GPT-4',
    source: '百度',
    category: 'AI',
    summary: '百度发布文心大模型5.0，在中文理解、创作、推理等方面全面超越GPT-4。文心5.0深度集成元宇宙场景，可实时生成3D场景、虚拟角色对话、元宇宙内容创作，成为中国元宇宙AI基础设施。',
    tags: ['百度', 'AI', '文心', '元宇宙'],
    url: '#',
  },
  {
    id: 34,
    date: '2025-01-30',
    title: '达沃斯论坛：全球领导人首次在元宇宙中举行峰会，虚拟外交时代开启',
    source: 'WEF',
    category: '元宇宙外交',
    summary: '世界经济论坛达沃斯年会首次在元宇宙中举行，来自50个国家的领导人通过XR设备参与虚拟峰会。会议讨论元宇宙治理、数字货币、AI监管等议题，标志着虚拟外交时代正式开启。',
    tags: ['达沃斯', '元宇宙', '外交', '全球治理'],
    url: '#',
  },
  {
    id: 35,
    date: '2025-01-15',
    title: '阿里巴巴发布"通义元宇宙"平台，AI生成内容让每个人都能创建自己的元宇宙',
    source: '阿里巴巴',
    category: 'AIGC',
    summary: '阿里巴巴发布通义元宇宙平台，用户只需用自然语言描述，AI即可自动生成完整的元宇宙场景、角色和互动逻辑。平台首月上线超过100万个用户创建的元宇宙空间。',
    tags: ['阿里巴巴', 'AIGC', '元宇宙', 'AI生成'],
    url: '#',
  },
  {
    id: 36,
    date: '2024-12-28',
    title: '2024年全球XR设备出货量突破1亿台，元宇宙硬件进入大众消费时代',
    source: 'IDC',
    category: 'XR设备',
    summary: 'IDC数据显示2024年全球XR设备出货量突破1亿台，同比增长250%。其中中国市场出货量3500万台，占全球35%。XR设备均价降至800美元以下，正式进入大众消费市场。',
    tags: ['XR', '出货量', '市场', '元宇宙'],
    url: '#',
  },
  {
    id: 37,
    date: '2024-12-15',
    title: '中国首个元宇宙国家标准体系发布，涵盖技术、安全、内容、交易四大领域',
    source: '国家标准化管理委员会',
    category: '标准',
    summary: '国家标准化管理委员会发布中国首个元宇宙国家标准体系，涵盖技术架构、数据安全、内容审核、数字资产交易四大领域共计120项标准，为元宇宙产业健康发展提供规范依据。',
    tags: ['标准', '中国', '元宇宙', '监管'],
    url: '#',
  },
  {
    id: 38,
    date: '2024-12-02',
    title: 'IBM量子计算机实现2000量子比特，量子互联网原型在美国东海岸成功测试',
    source: 'IBM',
    category: '量子计算',
    summary: 'IBM宣布其量子计算机实现2000个量子比特的稳定运行，并在美国东海岸城市间成功测试量子互联网原型。量子纠缠通信在300公里距离内实现，量子互联网商用化进程大幅提速。',
    tags: ['IBM', '量子计算', '量子互联网', '突破'],
    url: '#',
  },
  {
    id: 39,
    date: '2024-11-20',
    title: '索尼PlayStation VR3发布，与元宇宙平台深度整合，游戏与元宇宙边界消融',
    source: '索尼',
    category: 'XR设备',
    summary: '索尼发布PlayStation VR3，与主流元宇宙平台深度整合，玩家可在游戏与元宇宙之间无缝切换。设备支持全身动作捕捉，触觉反馈精度达到皮肤级别，沉浸感大幅提升。',
    tags: ['索尼', 'PlayStation', 'VR', '游戏'],
    url: '#',
  },
  {
    id: 40,
    date: '2024-11-08',
    title: '全球首个AI生成的元宇宙城市"新亚特兰蒂斯"开放，居民超过500万',
    source: 'Decentraland',
    category: 'AIGC',
    summary: 'Decentraland与OpenAI合作打造的全球首个完全由AI生成的元宇宙城市"新亚特兰蒂斯"正式开放，城市内所有建筑、景观、NPC均由AI实时生成，居民超过500万，虚拟GDP已超过部分小国。',
    tags: ['AIGC', 'Decentraland', '元宇宙城市', 'AI'],
    url: '#',
  },
  {
    id: 41,
    date: '2024-10-25',
    title: '脑机接口公司Synchron完成B轮融资10亿美元，非侵入式BCI商用化提速',
    source: 'Synchron',
    category: '脑机接口',
    summary: 'Synchron完成10亿美元B轮融资，由软银、谷歌风投领投。公司旗下Stentrode脑机接口设备已在全球完成200例临床试验，计划2026年推出消费级产品，定价低于5000美元。',
    tags: ['脑机接口', 'Synchron', '融资', '商用化'],
    url: '#',
  },
  {
    id: 42,
    date: '2024-10-12',
    title: '中国"东数西算"工程完成，算力网络支撑元宇宙大规模商用',
    source: '国家发展改革委',
    category: '算力基础设施',
    summary: '中国"东数西算"工程全面完成，全国算力网络总规模突破1000EFLOPS，成为全球最大算力网络。该网络将为元宇宙实时渲染、AI推理、数字孪生等应用提供充足算力支撑。',
    tags: ['东数西算', '算力', '中国', '元宇宙'],
    url: '#',
  },
  {
    id: 43,
    date: '2024-09-30',
    title: 'Web3.0游戏《星际公民》元宇宙版本上线，玩家资产总价值突破100亿美元',
    source: 'Cloud Imperium Games',
    category: 'Web3.0游戏',
    summary: 'Web3.0游戏《星际公民》元宇宙版本正式上线，玩家拥有的飞船、星球、装备等数字资产完全上链，总价值突破100亿美元。游戏内经济体系与现实经济深度融合，成为元宇宙经济的标杆案例。',
    tags: ['Web3.0', '游戏', '数字资产', '元宇宙经济'],
    url: '#',
  },
  {
    id: 44,
    date: '2024-09-18',
    title: '三星、LG联合发布裸眼3D电视，无需眼镜即可观看立体影像，元宇宙内容进入客厅',
    source: '三星/LG',
    category: '裸眼3D',
    summary: '三星和LG联合发布新一代裸眼3D电视，采用光场显示技术，多人同时观看均可获得最佳3D效果。配合元宇宙内容平台，用户无需任何设备即可在客厅享受沉浸式元宇宙体验。',
    tags: ['裸眼3D', '三星', 'LG', '显示技术'],
    url: '#',
  },
  {
    id: 45,
    date: '2024-09-05',
    title: '全球首个元宇宙大学"MetaU"开学，来自150个国家的学生在虚拟校园学习',
    source: 'MetaU',
    category: '教育',
    summary: '全球首个完全在元宇宙中运营的大学MetaU正式开学，首届招收来自150个国家的5万名学生。学生在虚拟校园中上课、实验、社交，学位获得全球50个国家认可，学费仅为传统大学的10%。',
    tags: ['教育', '元宇宙大学', '虚拟校园', '全球'],
    url: '#',
  },
  {
    id: 46,
    date: '2024-08-22',
    title: '英特尔发布神经形态芯片Loihi 3，模拟人脑神经元，AI推理能耗降低99%',
    source: 'Intel',
    category: '芯片',
    summary: '英特尔发布第三代神经形态芯片Loihi 3，模拟人脑1000亿神经元的工作方式，AI推理能耗比传统GPU降低99%。该芯片将使XR设备实现全天候AI增强现实，无需频繁充电。',
    tags: ['英特尔', '神经形态芯片', 'AI', 'XR'],
    url: '#',
  },
  {
    id: 47,
    date: '2024-08-10',
    title: '中国元宇宙产业联盟成立，华为、腾讯、阿里、百度等500家企业加入',
    source: '中国信息通信研究院',
    category: '产业联盟',
    summary: '中国元宇宙产业联盟在北京正式成立，华为、腾讯、阿里巴巴、百度、字节跳动等500家企业加入。联盟将推动元宇宙技术标准制定、产业生态建设、国际合作交流，打造中国元宇宙产业核心竞争力。',
    tags: ['产业联盟', '中国', '元宇宙', '科技巨头'],
    url: '#',
  },
  {
    id: 48,
    date: '2024-07-28',
    title: '全球首个量子卫星星座"墨子二号"发射成功，量子通信覆盖全球',
    source: '中国科学院',
    category: '量子通信',
    summary: '中国成功发射全球首个量子卫星星座"墨子二号"，由36颗量子卫星组成，实现全球量子通信覆盖。该系统将为元宇宙提供绝对安全的量子加密通信基础设施，防止任何形式的窃听。',
    tags: ['量子卫星', '中国', '量子通信', '安全'],
    url: '#',
  },
  {
    id: 49,
    date: '2024-07-15',
    title: 'Roblox与迪士尼合作，漫威、星球大战IP进入元宇宙，虚拟IP经济爆发',
    source: 'Roblox/Disney',
    category: 'IP元宇宙',
    summary: 'Roblox与迪士尼达成战略合作，漫威超级英雄、星球大战、皮克斯等顶级IP正式进入元宇宙。用户可与钢铁侠、尤达大师等角色互动，虚拟IP周边产品首月销售额突破10亿美元。',
    tags: ['Roblox', '迪士尼', 'IP', '元宇宙经济'],
    url: '#',
  },
  {
    id: 50,
    date: '2024-07-01',
    title: '全球元宇宙峰会发布《元宇宙首尔宣言》，确立元宇宙发展十大原则',
    source: '联合国教科文组织',
    category: '全球治理',
    summary: '联合国教科文组织主办的全球元宇宙峰会在首尔闭幕，发布《元宇宙首尔宣言》，确立元宇宙发展十大原则，包括数字包容、隐私保护、文化多样性、可持续发展等，为全球元宇宙治理奠定基础。',
    tags: ['联合国', '元宇宙治理', '首尔宣言', '全球'],
    url: '#',
  },
];
